import { GfxViewportElement } from './gfx/viewport-element.js';
import { VElement, VLine, VText } from './inline/index.js';
import { EditorHost } from './view/index.js';

function safeDefine(name: string, ctor: CustomElementConstructor) {
  if (!customElements.get(name)) {
    customElements.define(name, ctor);
  }
}

export function effects() {
  // editor host
  safeDefine('editor-host', EditorHost);
  // gfx
  safeDefine('gfx-viewport', GfxViewportElement);
  // inline
  safeDefine('v-element', VElement);
  safeDefine('v-line', VLine);
  safeDefine('v-text', VText);
}
